export default __webpack_public_path__ + "static/kubecon2-9939b82a7fd473d64e8634f0d201fcd3.webp";